import { ZCDFlex, ZCDTypography } from '@zencity/common-ui';
import { ZCDFlexProps } from '@zencity/common-ui/lib/ZCD/ZCDFlex/ZCDFlex';
import { ZCDIconProps } from '@zencity/common-ui/lib/ZCD/ZCDIcon/ZCDIcon';
import { ZCDTypographyProps } from '@zencity/common-ui/lib/ZCD/ZCDTypography/ZCDTypography';
import React from 'react';
import { NO_COMPARISON } from 'screens/WidgetGenerator/constants';
import { ChangeIcon } from './ChangeIcon';
import styles from './ChangeIndicator.module.scss';

interface Props {
  currentValue: number;
  prevValue?: number;
  iconColor?: ZCDIconProps['color'];
  justifyContent?: ZCDFlexProps['justifyContent'];
  typographyColor?: ZCDTypographyProps['color'];
  typographyVariant?: ZCDTypographyProps['variant'];
}

const calculateDiff = (current: number, prev?: number) => {
  if (prev === undefined) return undefined;

  return Math.round(current) - Math.round(prev);
};

// This component if dedicated to the ServicesBarChartWidget and is temporarily copied here.
// We will remove this component once we have a common-ui component for it.
// https://zencity.atlassian.net/browse/SRV-2318
export function ChangeIndicator(props: Props): React.ReactElement {
  const {
    currentValue,
    prevValue,
    iconColor,
    justifyContent = 'flex-start',
    typographyColor,
    typographyVariant,
  } = props;

  const change = calculateDiff(currentValue, prevValue);
  const noData = change === undefined;

  return (
    <ZCDFlex justifyContent={justifyContent} alignItems="center" width={65}>
      {noData ? (
        <ZCDTypography variant={typographyVariant} color={typographyColor} className={styles.noChangeIcon}>
          {NO_COMPARISON}
        </ZCDTypography>
      ) : (
        <ZCDFlex alignItems="center">
          <ChangeIcon
            typographyVariant={typographyVariant}
            typographyColor={typographyColor}
            change={change}
            iconColor={iconColor}
          />
          <ZCDTypography variant={typographyVariant} color={typographyColor}>{`${Math.abs(change)}%`}</ZCDTypography>
        </ZCDFlex>
      )}
    </ZCDFlex>
  );
}
